import { styled } from '@auth0/quantum-product';
export var Suggestions = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            alignItems: 'baseline',
            columnGap: theme.spacing(0.5),
            color: theme.palette.text.secondary
        },
        _b[theme.breakpoints.down(theme.layout.mobileBreakpoint)] = {
            flexDirection: 'column',
            alignItems: 'center',
        },
        _b);
});
